import { cn } from '@/lib/utils'

import { CaseAlertItem } from './case-alert-item/case-alert-item'
import { useCaseAlertList } from './use-case-alert-list'


interface CaseAlertListProps {
  isEoir?: boolean
}

export const CaseAlertList: React.FC<CaseAlertListProps> = ({ isEoir = false }) => {
  const { caseAlertList } = useCaseAlertList({ isEoir })

  if (!caseAlertList) return null

  return (
    <div className={cn('flex flex-col space-y-2')}>
      {caseAlertList.map((item, index) => (
        <CaseAlertItem key={item.id} item={item} order={index} />
      ))}
    </div>
  )
}
